/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import FeatherSvgLoader from '../../icons/feather'
import FontAwesomeSvgLoader from '../../icons/font-awesome'
import VacasaSvgLoader from '../../icons/vacasa'

const Iconic: React.FunctionComponent = () => {
  return (
    <div id="iconicWrapper">
      <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
        <FeatherSvgLoader />
        <FontAwesomeSvgLoader />
        <VacasaSvgLoader />
      </svg>
    </div>
  )
}

/**
 * The main wrapper component for Iconic. Loads all of the generated SVG components into
 * the DOM as SVG Symbols, which can then be used in `<svg><use>` elements.
 *
 * All you need to do to reap this component's benefits is simply mount it
 * in the DOM in the app's top-level component.
 */
export default React.memo(Iconic)
